/**
 * Determines whether MCP (Model Context Protocol) related functionality should be rendered.
 * This includes various MCP features such as server configuration menu, MCP-specific buttons,
 * and other MCP-related UI components in the Copilot chat interface.
 *
 * Currently used for features like:
 * - McpServerDialog component (shared dialog for adding/configuring MCP servers)
 * - Other MCP-related functionality in immersive chat mode
 *
 * @param mcpFeatureFlag - Whether the MCP feature flag is enabled
 * @param currentMode - The current chat mode ('immersive' | 'assistive' | etc.)
 * @param isOnSpacePath - Whether the current path is a Copilot Space path (MCP features are hidden when true)
 * @returns true if MCP-related functionality should be rendered, false otherwise
 */
export const shouldShowMcpFeatures = (
  mcpFeatureFlag: boolean,
  currentMode: string,
  isOnSpacePath: boolean,
): boolean => {
  return mcpFeatureFlag && currentMode === 'immersive' && !isOnSpacePath
}
